export class Meses {

  public static meses = [
      { numero: 1, nome_abrev: 'JAN', ultimoDia: 31, mes_nome: 'JANEIRO', nomeMesLower: 'Janeiro', marked: false },
      { numero: 2, nome_abrev: 'FEV', ultimoDia: 28, mes_nome: 'FEVEREIRO', nomeMesLower: 'Fevereiro', marked: false },
      { numero: 3, nome_abrev: 'MAR', ultimoDia: 31, mes_nome: 'MARÇO', nomeMesLower: 'Março', marked: false },
      { numero: 4, nome_abrev: 'ABR', ultimoDia: 30, mes_nome: 'ABRIL', nomeMesLower: 'Abril', marked: false},
      { numero: 5, nome_abrev: 'MAI', ultimoDia: 31, mes_nome: 'MAIO', nomeMesLower: 'Maio', marked: false },
      { numero: 6, nome_abrev: 'JUN', ultimoDia: 30, mes_nome: 'JUNHO', nomeMesLower: 'Junho', marked: false },
      { numero: 7, nome_abrev: 'JUL', ultimoDia: 31, mes_nome: 'JULHO', nomeMesLower: 'Julho', marked: false },
      { numero: 8, nome_abrev: 'AGO', ultimoDia: 31, mes_nome: 'AGOSTO', nomeMesLower: 'Agosto', marked: false },
      { numero: 9, nome_abrev: 'SET', ultimoDia: 30, mes_nome: 'SETEMBRO', nomeMesLower: 'Setembro', marked: false },
      { numero: 10, nome_abrev: 'OUT', ultimoDia: 31, mes_nome: 'OUTUBRO', nomeMesLower: 'Outubro', marked: false },
      { numero: 11, nome_abrev: 'NOV', ultimoDia: 30, mes_nome: 'NOVEMBRO', nomeMesLower: 'Novembro', marked: false },
      { numero: 12, nome_abrev: 'DEZ', ultimoDia: 31, mes_nome: 'DEZEMBRO', nomeMesLower: 'Dezembro', marked: false }
    ];
  }
  

    